<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div id="app" class="column is-half is-offset-one-quarter has-text-left">
          <form @submit="handleLogin">
            <b-field label="Username">
              <b-input v-model="credentials.username"></b-input>
            </b-field>
            <b-field label="Password">
              <b-input type="password" v-model="credentials.password" password-reveal></b-input>
            </b-field>
            <button class="button is-fullwidth" @click="login(credentials)">LOGIN</button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'Login',
    data () {
      return {
        credentials: {
          username: '',
          password: ''
        },
        loginError: false
      }
    },
    methods: {
      ...mapActions(['login']),
      invalidUsername () {
        return !this.loginError || ''
      },
      invalidPassword () {
        return !this.loginError || 'The username and password you entered don\'t match'
      },
      handleLogin (e) {
        e.preventDefault()
        this.login(this.credentials)
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Login.vue?75aa665a